export enum ProjectSortOrder {
  NEWEST_FIRST,
  OLDEST_FIRST,
  PROJECT_PROGRESS,
  DRYING_END_OVERDUE_FIRST,
  URGENCY,
  PROJECT_NUMBER,
}

